import React from "react";
import { useDispatch } from "react-redux";
import { closeModal } from "../../features/modal/ModalSlice";
import { Modal } from "react-bootstrap";
import Login from "../Auth/Login/Login";

const LoginPopUp = () => {
  const dispatch = useDispatch();

  // const handlelogin = () => {
  //   // dispatch(
  //   //   SetPopupReducerData({
  //   //     modalType: "LOGIN",
  //   //     showModal: true,
  //   //   })
  //   // );
  // };

  //   const Loader = () => {
  //     return (
  //       <div
  //         style={{
  //           display: "flex",
  //           justifyContent: "center",
  //           alignItems: "center",
  //           position: "fixed",
  //           top: "0",
  //           left: "0",
  //           width: "100%",
  //           height: "100%",
  //           zIndex: "1000",
  //           backgroundColor: "rgba(255, 255, 255, 0.5)",
  //         }}
  //       >
  //         <Oval visible={true} height="80" width="80" color="#4fa94d" ariaLabel="oval-loading" />
  //       </div>
  //     );
  //   };

  const handleClosePopup = () => {
    dispatch(closeModal());
  };

  return (
    <Modal
      show={true}
      onHide={handleClosePopup}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="taskModal"
    >
      <Modal.Body className="px-5">
        <Login />
      </Modal.Body>
    </Modal>
  );
};

export default LoginPopUp;
